import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/billingPaymentTrack/detailsRequestDialogStyle';
import { Caption, CaptionBold } from 'components/Typography/Typography';
import { OfflinePayment } from 'utils/api/models/billingPaymentTrack/offlinePayment';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { PAYMENT_TYPE } from 'views/BillingPaymentTrack/commons/constants';
import moment from 'moment';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDetailsRequestDialog {
	isOpen: boolean;
	hideDialog: () => void;
	offlinePayment: OfflinePayment | undefined;
	bankName: string | undefined;
}

const DetailsRequestDialog = ({ isOpen, hideDialog, offlinePayment, bankName }: IDetailsRequestDialog) => {
	const classes = useStyles();
	return (
		<CustomDialog
			header={translate('billing.payment.track.details.request.dialog.title')}
			isOpen={isOpen}
			hideDialog={hideDialog}
			width={668}
			dialogBody={
				<div className={classes.contentContainer}>
					<div className={classes.section}>
						<DetailsRequestRow
							title={translate('billing.payment.track.details.request.dialog.approval.date')}
							value={
								offlinePayment?.approvalDate
									? moment(offlinePayment?.approvalDate).format('DD.MM.YYYY')
									: ''
							}
						/>
					</div>
					<div className={classes.section}>
						<DetailsRequestRow
							title={translate('billing.payment.track.details.request.dialog.invoice.type')}
							value={
								offlinePayment?.invoiceType
									? translate(
											`billing.payment.track.details.request.dialog.invoice.type.${offlinePayment.invoiceType}`
									  )
									: 'No data'
							}
						/>
						<DetailsRequestRow
							title={translate('billing.payment.track.details.request.dialog.payment.type')}
							value={
								offlinePayment?.paymentType
									? translate(`billing.payment.track.payment.type.${offlinePayment.paymentType}`)
									: 'No data'
							}
						/>
					</div>
					<div className={classes.section}>
						<DetailsRequestRow
							title={translate('billing.payment.track.details.request.dialog.bank.name')}
							value={bankName}
						/>
						<ConditionalRender
							show={offlinePayment?.paymentType === PAYMENT_TYPE.CHEQUE_DEPOSIT}
							onTrue={() => (
								<DetailsRequestRow
									title={translate('billing.payment.track.details.request.dialog.bank.cheque.number')}
									value={offlinePayment?.chequeNumber}
								/>
							)}
							onFalse={() => (
								<DetailsRequestRow
									title={translate(
										'billing.payment.track.details.request.dialog.bank.account.number'
									)}
									value={offlinePayment?.bankAccountNumber}
								/>
							)}
						/>
						<div className={classes.row}>
							<DetailsRequestRow
								title={translate('billing.payment.track.details.request.dialog.bank.total.amount.paid')}
								value={
									offlinePayment?.totalAmountPaid
										? offlinePayment.totalAmountPaid.toFixed(3) + ' OMR'
										: 'No data'
								}
							/>
						</div>

						<ConditionalRender
							show={!!offlinePayment?.statusDescription}
							onTrue={() => (
								<div className={classes.row}>
									<DetailsRequestRow
										title={translate('billing.payment.track.details.request.dialog.comment')}
										value={offlinePayment?.statusDescription}
									/>
								</div>
							)}
						/>
					</div>
				</div>
			}
		/>
	);
};

const DetailsRequestRow = ({ title, value }: { title: string; value: string | undefined }) => {
	const classes = useStyles();
	return (
		<div className={classes.row}>
			<div className={classes.columnLeft}>
				<CaptionBold disableMargin inline>
					{title}
				</CaptionBold>
			</div>
			<div className={classes.columnRight}>
				<Caption disableMargin inline>
					{value || ''}
				</Caption>
			</div>
		</div>
	);
};

export default DetailsRequestDialog;
